// components/StepIndicator.js
import React from 'react';

function StepIndicator({ steps, currentStep }) {
    return (
        <div className="step-indicator-container">
            {/* 背景连接线 */}
            <div className="step-line"></div>

            {/* 进度连接线 */}
            <div
                className="step-line-progress"
                style={{
                    width: `${(currentStep / (steps.length - 1)) * 100}%`
                }}
            ></div>

            {/* 步骤点 */}
            {steps.map((step, index) => (
                <div key={index} className="step-item">
                    <div
                        className={`step-circle ${
                            currentStep === index
                                ? 'active'
                                : currentStep > index
                                    ? 'completed'
                                    : 'upcoming'
                        }`}
                    >
                        {currentStep > index ? '✓' : index + 1}
                    </div>
                    <div
                        className={`step-title ${
                            currentStep === index
                                ? 'active'
                                : currentStep > index
                                    ? 'completed'
                                    : 'upcoming'
                        }`}
                    >
                        {step}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default StepIndicator;